import BaseModule from './base-module';

// 账户
class User extends BaseModule {
  // 获取当前用户基本信息
  info(params) {
    return this.get('/user/info', { params });
  }

  // 注销登陆
  logout(params) {
    return this.put('/user/logout', params);
  }
}

export default new User();
